import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Title from 'antd/es/typography/Title'
import { Divider } from 'antd'
import BrowserBorder from '../../component/showcase/BrowserBorder'
import ContactPage from '../../component/showcase/ContactPage'
import { getArtist, getArtistProfilePublic, patchArtist } from '../../api/artists'
import HttpError from '../../component/base/HttpError'
import { UpdateSuccess } from '../../component/base/HttpMessage'
import ShowcasePreviewLayout from '../../component/showcase/ShowcasePreviewLayout'

@connect((state) => ({
  //decorator, gives component access to the state
  siderWidth: state.style.siderWidth,
  id: state.user.info.id,
  userId: state.user.info.userId,
  artistId: state.user.info.artistId,
  artistName: state.user.info.artistName
}))
class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: null,
      social_instagram: null,
      social_facebook: null,
      social_linkedin: null
    }
    this.onUpdateSocial = this.onUpdateSocial.bind(this)
    this.onNewContactInfo = this.onNewContactInfo.bind(this)
    this.artistId = this.props.artistId
  }

  async componentDidMount() {
    this.IS_MOUNT = true
    const profileRes = await getArtistProfilePublic(this.artistId)
    if (profileRes.status === 404) {
      return
    }
    if (this.IS_MOUNT) {
      this.setState({
        profile: profileRes.data
      })
    }

    getArtist(this.props.userId)
      .then((res) => {
        if (this.IS_MOUNT) {
          this.setState({
            social_instagram: res.data.social_instagram,
            social_facebook: res.data.social_facebook,
            social_linkedin: res.data.social_linkedin
          })
        }
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })
  }

  componentWillUnmount() {
    this.IS_MOUNT = false
  }

  onUpdateSocial(data) {
    patchArtist(this.props.userId, {
      social_instagram: data.social_instagram,
      social_facebook: data.social_facebook,
      social_linkedin: data.social_linkedin
    })
      .then((r) => {
        if (this.IS_MOUNT) {
          UpdateSuccess()
          this.setState({
            social_instagram: data.social_instagram,
            social_facebook: data.social_facebook,
            social_linkedin: data.social_linkedin
          })
        }
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })
  }

  onNewContactInfo = (data) => {
    if (!data) return
    let message = ''
    Object.keys(data).forEach((key) => {
      if (key && data[key]) {
        message += '<p>' + key + ' : ' + data[key] + '</p>'
      }
    })
    // postNotification({
    //     title: 'New Contact Message',
    //     message: message,
    //     receiver: [this.props.userId]
    // }).then((res)=>{
    // }).catch((error)=>{
    //     if (!this.IS_MOUNT) return
    //     HttpError(error)
    // })
  }

  render() {
    return (
      <ShowcasePreviewLayout {...this.props}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
          <div>
            <Title style={{ marginBottom: 0 }}>Contact</Title>
          </div>
        </div>
        <div></div>
        <Divider />
        <BrowserBorder {...this.props}>
          <ContactPage
            {...this.props}
            profile={this.state.profile}
            onContactSocialSubmit={this.onUpdateSocial}
            onContactFormSubmit={this.onNewContactInfo}
            social_instagram={this.state.social_instagram}
            social_facebook={this.state.social_facebook}
            social_linkedin={this.state.social_linkedin}
          />
        </BrowserBorder>
      </ShowcasePreviewLayout>
    )
  }
}

export default withRouter(Contact)
